import { gql } from '@apollo/client'

import { BASKET_FRAGMENT } from '../../queries'

export const LINE_ITEM_REMOVE = gql`
  mutation CartLineItemRemove($lineItemId: ID!) {
    basketLineItemRemove(lineItemId: $lineItemId) {
      ...CartBasket
    }
  }

  ${BASKET_FRAGMENT}
`

export const LINE_ITEM_QUANTITY_EDIT = gql`
  mutation CartLineItemQuantityEdit($lineItemId: ID!, $quantity: Int!) {
    basketLineItemQuantityEdit(lineItemId: $lineItemId, quantity: $quantity) {
      ...CartBasket
    }
  }

  ${BASKET_FRAGMENT}
`
